import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=44928b7f&scoped=true&"
import script from "./LabelSelector.vue?vue&type=script&lang=js&"
export * from "./LabelSelector.vue?vue&type=script&lang=js&"
import style0 from "./LabelSelector.vue?vue&type=style&index=0&id=44928b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44928b7f",
  null
  
)

export default component.exports